<template>
  <div class="overlay h-screen flex flex-col items-center justify-center">
    <div v-if="isVisible" class="spinner flex flex-col items-center justify-center">
      <Spinner />
      <p class="text m-[30px] font-extralight">{{ $t('components.loader.message') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, onMounted, ref } from 'vue';
import { isVonageBrand } from '@/constants';

const Spinner = defineAsyncComponent(() => import(isVonageBrand ? './VonageSpinner.vue' : './CircleDotSpinner.vue'));

const isVisible = ref(false);
onMounted(() =>
  // avoid showing loader for sub 100ms transitions
  // as it is too jarring
  setTimeout(() => {
    isVisible.value = true;
  }, 100)
);
</script>
